
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"7.2","cy":"6.2","r":"3.2","fill":"#E345FF"}}),_c('path',{attrs:{"d":"M1.7 17.5c0-3.6 2.461-6.1 5.5-6.1s5.5 2.5 5.5 6.1h-11z","fill":"#5935DD"}}),_c('circle',{attrs:{"cx":"13.7","cy":"7","r":"2.6","fill":"#5935DD"}}),_c('path',{attrs:{"d":"M10.9 17.5c.3-2.9 2.25-4.9 4.6-4.9 1.971 0 3.3 1.845 3.3 4.9h-7.9z","fill":"#E345FF"}})])
          )
        }
      }
    